import ApiError from "./";
import ProblemDetail, {isProblemDetail} from "./problem-detail";
export default class AuthorizationError extends ApiError {
  readonly name: string = "AuthorizaitonError";

  constructor(problem: AuthorizationProblem) {
    super(problem);
  }
}

export type AuthorizationProblem = ProblemDetail;

export function isAuthorizationProblem(obj: unknown): obj is AuthorizationProblem {
  if (isProblemDetail(obj)) {
    return obj.status == 403;
  }
  return false;
}
